const body = document.querySelectorAll('body')[0];
const search = document.getElementById('sb-search');

if (search) {
    const searchInput = search.getElementsByClassName('sb-search-input')[0];
    const searchButton = search.getElementsByClassName('sb-search-submit')[0];
    const searchIcon = search.getElementsByClassName('sb-icon-search')[0];
    const header = document.getElementsByClassName('l-header')[0];

    function openSearch() {
        search.classList.add('sb-search-open');
        header.classList.add('-search-open');
        searchInput.focus();
    }

    searchIcon.addEventListener('click', () => {
        openSearch();
    });

    searchInput.onfocus = function () {
        openSearch();
    };

    searchButton.addEventListener('click', (e) => {
        if (searchInput.value.trim() === '') {
            e.preventDefault();
            e.stopPropagation();
            search.classList.remove('sb-search-open');
            header.classList.remove('-search-open');
        }
    });

    body.addEventListener('click', (e) => {
        if (search.classList.contains('sb-search-open')) {
            if (!search.contains(e.target)) {
                e.preventDefault();
                e.stopPropagation();
                search.classList.remove('sb-search-open');
                header.classList.remove('-search-open');
            }
        }
    });
}
